import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { search, mapObject, enumObject, any, arrayToMap, filterObject, all } from "keautils";

import { RolTreeType, DeclaracionRoles } from "../rolmap";

export interface FiltroRol {
    habilitados?: boolean;
    busqueda?: string;
}

interface Hoja {
    key: string;
    path: string;
    descripcion: string;
    valor: boolean;
}
type PartialDeep<T> = {[K in keyof T]?: PartialDeep<T[K]> };

interface Arbol {
    [K: string]: Arbol | string | undefined;
}
interface Valor {
    [K: string]: Valor | boolean;
}
type ArbolValor = {
    path: string;
    key: string;
    arbol: Arbol,
    valor: Valor
} | {
        path: string;
        key: string;
        arbol: string,
        valor: boolean
    } | {
        path: string;
        key: string,
        arbol: undefined,
        valor: undefined
    };

function filtrarNodo(nodo: ArbolValor, pred: (nodo: Hoja) => boolean): Arbol | string | undefined {
    if (nodo.arbol == undefined) return undefined;

    if (typeof (nodo.arbol) == "string") {
        const nodoPred: Hoja = {
            key: nodo.key,
            path: nodo.path,
            descripcion: nodo.arbol,
            valor: nodo.valor as boolean
        };
        const pasaFiltro = pred(nodoPred);
        return pasaFiltro ? nodo.arbol : undefined;
    } else {
        const hijos: ArbolValor[] = enumObject(mapObject(nodo.arbol, (val, key) => ({
            key: key,
            arbol: val,
            path: nodo.path + " " + key,
            valor: (nodo.valor as any)[key]
        })))
            .map(x => x.value as ArbolValor)
            ;

        const hijosFiltrados = hijos.map(x => ({
            key: x.key,
            arbol: filtrarNodo(x, pred)
        })).filter(x => !!x.arbol).map(x => ({
            key: x.key,
            arbol: x.arbol!
        }));

        const tieneHijos = any(hijosFiltrados);
        if (!tieneHijos) return undefined;

        const hijosArbol: Arbol =
            arrayToMap(
                hijosFiltrados.map(x => ({
                    key: x.key,
                    value: x.arbol
                }))
            );
        return hijosArbol;
    }
}

/**Filtra el arbol de roles  dado un predicado de filtrado */
function filtrarArbolRolesPred(arbol: Arbol, valor: Valor, predicate: (nodo: Hoja) => boolean): Arbol {
    const nodo: ArbolValor = {
        arbol: arbol,
        key: "",
        path: "",
        valor: valor
    };
    const ret = filtrarNodo(nodo, predicate) as (Arbol | undefined);
    return ret || {};
}

/**Obtiene la declaracion filtrada de los roles */
export function obtenerArbolRolesFiltrado(rol: models.Rol, filtro: FiltroRol) {
    if (!filtro.busqueda && filtro.habilitados == null) {
        return DeclaracionRoles;
    } else {
        const pred = (x: Hoja) =>
            (search(filtro.busqueda, x.path + " " + x.descripcion)) &&
            (
                filtro.habilitados == null ||
                (filtro.habilitados == x.valor)
            );
        return filtrarArbolRolesPred(DeclaracionRoles as Arbol, rol as any as Valor, pred);
    }
}

/**Devuelve el nuevo valor con todos los elementos seleccionados */
export function establecerValorTodos(arbol: Arbol, valor: any, establecer: boolean): any {
    return mapObject(arbol, (val, key) => {
        const v = val;
        if (v == undefined) {
            //Si val es undefined, preservamos el valor
            return valor[key];
        } else if (typeof (v) == "string") {
            return establecer;
        } else {
            return establecerValorTodos(v as any, valor[key], establecer);
        }
    })
}

/**Devuelvet true si todos los elementos en el arbol tienen el mismo valor individual */
export function tieneTodosMismoValor(arbol: Arbol, valor: any, valorSingle: boolean, debugPath: string): boolean {
    if(valor == null) {
        throw new Error("No se encontro valor en la ruta: " + debugPath);
    }
    const map = 
        enumObject(filterObject(arbol, (val,key) => val != undefined))
        .map(x => {
            return typeof(x.value) == "string" ? (valor[x.key]  == valorSingle) : tieneTodosMismoValor(x.value as Arbol, valor[x.key], valorSingle, debugPath + "/" + x.key);
        });
    return all(map, x => x);
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/roles/edit/componentes/logic.tsx